import { AppDialogService } from './../../services/app-dialog.service';
import { Injectable } from '@angular/core';
import * as TankProfileActions from '../actions/tank-profile.actions';
import * as UserProfileActions from '../actions/user-profile.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ITankProfile } from '../../interfaces/tankProfile';
import { ITankProfileChangeRequest } from '../../interfaces/tankProfile';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { TankProfileService } from '../../services/tank-profile.service';
import { LogService } from '../../services/log.service';
import { of } from 'rxjs';

@Injectable()
export class TankProfileEffect {

  constructor(private actions$: Actions,
    private store: Store<AppState>,
    private tankProfileService: TankProfileService,
    private logger: LogService,
    private appDialogService: AppDialogService,) {
  };

  //save Tank Profile (Effect) via Tank Profile Service
  //On Success - Show Snackbar and return new Success Action (save Tank Profile to state store)
  //On Error - Show Snackbar and return new Failure Action
  // saveTankProfile$ = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(TankProfileActions.SAVE_TANK_PROFILE),
  //     exhaustMap(action => {
  //       const { tankProfile } = action as TankProfileActions.SaveTankProfile;
  //       return this.tankProfileService.saveTankProfile(tankProfile).pipe(
  //         switchMap((savedProfile: ITankProfile) => {
  //           this.appDialogService.showSuccessMessage('Tank Profile Saved');
  //           const actions: Action[] = [
  //             new TankProfileActions.SaveTankProfileSuccess(savedProfile),
  //           ];
  //           return actions;
  //         }),
  //         catchError((error) => {
  //           this.appDialogService.showErrorMessage('Tank Profile Save Failed');
  //           return of({
  //             type: TankProfileActions.SAVE_TANK_PROFILE_FAILURE,
  //             error
  //           });
  //         })
  //       );
  //     })
  //   );
  // });

  //create a new Tank Profile (Effect) via Tank Profile Service
  //On Success - Show Snackbar and return new Success Action (save Tank Profile to state store)
  //On Error - Show Snackbar and return new Failure Action
  // createTankProfile$ = createEffect(() => {
  //   let tp: ITankProfile = null;
  //   return this.actions$.pipe(
  //     //filter for only Create Tank Profile Action
  //     ofType(TankProfileActions.CREATE_TANK_PROFILE),
  //     //Call service to create it, exhaust mapping to ensure all tasks complete.
  //     exhaustMap(action => {


  //       //serialize for persistance
  //       tp = (action as TankProfileActions.CreateTankProfile).tankProfile;

  //       //call the service, return the observable response
  //       return this.tankProfileService.createTankProfile(tp);
  //     }),
  //     map((tankProfile: ITankProfile) =>{
  //       let newTp: ITankProfile = {
  //         ...tp,
  //         tankProfileId: tankProfile.tankProfileId,
  //       };
  //       return newTp;
  //     }),
  //     switchMap((tankProfile: ITankProfile) => {
  //       this.appDialogService.showSuccessMessage('Tank Profile Created');
  //       return [
  //         new TankProfileActions.CreateTankProfileSuccess(tankProfile),
  //         new TankProfileActions.ActiveTankProfileChanged(tankProfile)
  //     ];
  //     }),
  //     catchError((error) => {
  //       this.appDialogService.showErrorMessage('Tank Profile Create Failed');
  //       return of({
  //         type: TankProfileActions.CREATE_TANK_PROFILE_FAILURE,
  //         error: error
  //       });
  //     })
  //   )
  // });

  //process the tank profile change
  //On Success - Show Snackbar and return new Tank Profile Fetched Action (save Tank Profile to state store)
  //On Error - Show Snackbar and return new Failure Action
  changeTankProfile$ = createEffect(() => {

    let tp: ITankProfile = null;
    return this.actions$.pipe(
      ofType(TankProfileActions.ACTIVE_TANK_PROFILE_CHANGED),
      exhaustMap(action => {
        tp = (action as TankProfileActions.ActiveTankProfileChanged).tankProfile;
        let changeRequest: ITankProfileChangeRequest = {
          profileId: tp.tankProfileId,
          organizationId: tp.organizationId,
          isTVP: tp.isTVP,
          previousTvpId: tp.tankViewProfileId,
          isNewUser: false
        }
        return this.tankProfileService.changeActiveTankProfileTo(changeRequest);
      }),
      switchMap((result: ITankProfile) => {
        //return a save tank profile success message
        this.logger.log("ACTIVE_TANK_PROFILE_CHANGED ", result);
        this.appDialogService.showGeneralMessage(`Tank Profile Changed to ${result.tankProfileName}`);

        this.logger.setCustomVariable(0, "Cso", result.organizationId.toString(), "page");
        this.logger.setCustomVariable(1, "TankProfile", result.tankProfileId.toString(), "page");
        this.logger.trackPageView("dashboard");

        return [
          new TankProfileActions.TankProfileFetched(result),
          new UserProfileActions.SetLastSelectedTankProfile(result),
          new TankProfileActions.UpdateCurrentTankProfile(result),
          //new FilterProfileActions.ChangeFilterProfile(null)
        ];

      }),

      catchError((error) => {
        this.appDialogService.showErrorMessage('Tank Profile Change Failed');
        return of({
          type: TankProfileActions.SAVE_TANK_PROFILE_FAILURE,
          error: error
        });
      })
    )
  });

}
